angular.module('tgaAdmin')
  .controller('GameCopySubdomainModalController', [
    '$scope', '$state', '$window', '$uibModalInstance', '$uibModalStack',
    '$filter', 'userService', 'gameService', 'extras',
    function (
      $scope, $state, $window, $uibModalInstance, $uibModalStack,
      $filter, userService, gameService, extras,
    ) {
      $scope.data = {
        alerts: [],
        closeButton: true,
        domains: [], // list of domains
        domain: null, // current domain
        usesQuestionList: false, // whether gameData.question_list_id !== null,
        usesQlMessage: $filter('translate')('modal.copy_game_subdomain.ql_error'),
        subscriptionMessage: $filter('translate')('modal.copy_game_subdomain.sub_error'),
        canSubmit: true, // unless game has questionlist or dest domain doesnt have game sub
        errorMessage: '', // fill with usesQlMessage subscriptionMessage
      };

      $scope.viewmodel = {
        domain: null, // the domain chosen by the user in this modal
      };

      $scope.initialize = function () {
        $scope.data.domains = extras.domains;
        $scope.data.domain = extras.domain;
        $scope.viewmodel.domain = extras.domain;
        $scope.data.usesQuestionList = extras.usesQuestionList;

        // console.log("domains: ", extras.domains);
      };

      $scope.actions = {
        submit(form) {
          // console.log('submitted form');
          form.submitted = true;

          $scope.data.alerts = [];

          if (form.$invalid) {
            // console.log('form invalid');
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> ${$filter('translate')('check_form_for_errors')}`,
              'danger',
            );
            return;
          }

          $uibModalStack.getTop().value.backdrop = 'static';
          $uibModalStack.getTop().value.keyboard = false;
          $scope.data.closeButton = false; // disable for a moment

          $scope.processing = true;

          // Double check usesQuestionList constraint
          if ($scope.data.domain !== $scope.viewmodel.domain && $scope.data.usesQuestionList) {
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${$scope.data.usesQlMessage}`,
              'danger',
            );
            // console.log('failed QL constraint', $scope.data, $scope.viewmodel);
            $scope.data.closeButton = true; // re-enable on error
            $scope.processing = false;
            return;
          }

          // Send back the chosen domain.
          // console.log('sending back the value of: ', $scope.viewmodel.domain);
          $scope.processing = false;
          $uibModalInstance.close($scope.viewmodel.domain);
        },
        createAlert(msg, type) {
          $scope.data.alerts = [];
          $scope.data.alerts.push({
            msg,
            type,
          });
        },
        close() {
          $uibModalInstance.dismiss();
        },
        checkDomainValid(form) {
          // console.log('form was ', form);
          let valid = true;
          // console.log('subdomain modal: domains are ', $scope.data.domains,
          //   'and the chosen domain is', $scope.viewmodel.domain,
          //   'and the current domain is', $scope.data.domain);

          // Check Question List constraint first, then check subscription constraint.
          const chosenDomain = $scope.data.domains.filter((domain) => domain.value === $scope.viewmodel.domain)[0];

          if ($scope.data.usesQuestionList && $scope.data.domain !== $scope.viewmodel.domain) {
            valid = false;
            $scope.data.errorMessage = `${$scope.data.usesQlMessage}`;
            // console.log('failed QL constraint');
          } else if (!chosenDomain.copyable) {
            valid = false;
            $scope.data.errorMessage = `${$scope.data.subscriptionMessage}`;
            // console.log('failed subscription constraint');
          }

          $scope.data.canSubmit = !!valid;
          if (valid) {
            form.domain.$setValidity('required', true);
            $scope.data.errorMessage = '';
            // console.log('passed domain validation');
          } else {
            form.domain.$setValidity('required', false);
            $scope.actions.createAlert(
              `<span class="fa fa-exclamation-triangle"></span> <strong>Error!</strong> ${$scope.data.errorMessage}`,
              'danger',
            );
          }
        },
      };
      $scope.initialize();
    },
  ]);
